import React from "react";

export default function ImagePlaceholder({ className = "", icon = "fa-light fa-horse", text = "Equinesport" }) {
  return (
    <div className={`w-full h-full bg-stone-200 dark:bg-stone-800 flex flex-col items-center justify-center text-stone-400 p-6 select-none border border-stone-300/40 ${className}`}>
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-stone-100/60 dark:bg-stone-700/40 mb-3">
        <i className={`${icon} text-xl text-stone-500/70`} aria-hidden="true" />
      </div>
      {text && (
        <span className="text-[9px] uppercase tracking-[0.3em] font-semibold text-stone-500/70 font-sans-custom">
          {text}
        </span>
      )}
    </div>
  );
}
